<ng-container *transloco="let t; prefix:'customers.customersDetail'">
    <h2 mat-dialog-title class="dialog-header">
        <span class="dialog-title title-large">{{ t(dialogTitleKey) }}</span>

        <button
            mat-icon-button
            type="button"
            [attr.aria-label]="t('contacts.form.closeAriaLabel')"
            class="close-button"
            (click)="onClose()"
        >
            <i class="fa-regular fa-xmark"></i>
        </button>
    </h2>

    <mat-dialog-content class="content" [formGroup]="addContactForm">
        <mat-form-field appearance="outline">
            <mat-label>{{ t('contacts.form.fullName') }}</mat-label>
            <input matInput formControlName="nomeCognome">
            <mat-error>{{ t('contacts.form.fullNameRequired') }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{ t('contacts.form.phone') }}</mat-label>
            <input matInput formControlName="telefono">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{ t('contacts.form.mobile') }}</mat-label>
            <input matInput formControlName="cellulare">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{ t('contacts.form.fax') }}</mat-label>
            <input matInput formControlName="fax">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{ t('contacts.form.email') }}</mat-label>
            <input matInput formControlName="email">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{ t('contacts.form.role') }}</mat-label>
            <input matInput formControlName="ruolo">
        </mat-form-field>

        <mat-form-field appearance="outline" class="text-area-custom">
            <mat-label>{{ t('contacts.form.notes') }}</mat-label>
            <textarea matInput formControlName="note" rows="3"></textarea>
        </mat-form-field>

        <mat-slide-toggle formControlName="default" labelPosition="before">
            {{ t('contacts.mainContact') }}
        </mat-slide-toggle>
    </mat-dialog-content>

    <mat-dialog-actions class="buttons-container">
        <button matButton (click)="onReset()">{{ t('contacts.form.reset') }}</button>
        <button matButton="filled" (click)="onApply()">{{ t('contacts.form.apply') }}</button>
    </mat-dialog-actions>
</ng-container>
